import { getStateFor } from './getScopedStateInstance';
import { getGlobalState } from './initialize';
const scopeOrder = ['TAB', 'BROWSING_CONTEXT', 'EXECUTION_CONTEXT'];
export const canUse = () => !!getGlobalState();
export const debug = qualifier => {
  const groupName = qualifier ? `Silo — ${qualifier}` : 'Silo';
  console.groupCollapsed(groupName);
  for (const scope of scopeOrder) {
    console.group(scope);
    for (const [key, value] of getStateFor(scope).values.entries()) {
      console.log(key, '-', value);
    }
    console.groupEnd();
  }
  console.groupEnd();
};
export const has = descriptor => getStateFor(descriptor.scope).values.has(descriptor.name);
export const get = descriptor => {
  if (!has(descriptor)) {
    return descriptor.initialValue;
  }
  return getStateFor(descriptor.scope).values.get(descriptor.name);
};
export const getOrThrow = descriptor => {
  if (!has(descriptor)) {
    throw Error(`Value for descriptor ${descriptor.name} in ${descriptor.scope} scope was not set.`);
  }
  return getStateFor(descriptor.scope).values.get(descriptor.name);
};
const notify = ({
  name,
  scope
}) => {
  var _watchers$get;
  const {
    values,
    watchers
  } = getStateFor(scope);
  (_watchers$get = watchers.get(name)) === null || _watchers$get === void 0 || _watchers$get.forEach(watcher => {
    const unwatch = () => {
      var _watchers$get2;
      return (_watchers$get2 = watchers.get(name)) === null || _watchers$get2 === void 0 ? void 0 : _watchers$get2.delete(watcher);
    };
    watcher(values.get(name), unwatch);
  });
};
export const set = (property, value) => {
  if (property.readOnly) {
    throw new Error(`Property ${property.name} is read-only`);
  }
  getStateFor(property.scope).values.set(property.name, value);
  notify(property);
};
export const update = (property, updater) => set(property, updater(get(property)));
export const updateOrThrow = (property, updater) => set(property, updater(getOrThrow(property)));
export const clear = property => {
  if (property.readOnly) {
    throw new Error(`Property ${property.name} is read-only`);
  }
  getStateFor(property.scope).values.delete(property.name);
  notify(property);
};
export const watch = property => callback => {
  const {
    name,
    scope
  } = property;
  const {
    values,
    watchers
  } = getStateFor(scope);
  watchers.set(name, new Set([...(watchers.get(name) || []), callback]));
  const unwatch = () => {
    var _watchers$get3;
    return (_watchers$get3 = watchers.get(name)) === null || _watchers$get3 === void 0 ? void 0 : _watchers$get3.delete(callback);
  };
  if (values.get(name)) {
    callback(values.get(name), unwatch);
  }
  return unwatch;
};
export const createScopedDescriptor = (name, scope, readOnly = false, initialValue) => {
  const descriptor = {
    name,
    scope,
    readOnly,
    initialValue
  };
  if (canUse() && !has(descriptor) && initialValue !== undefined) {
    set({
      name,
      scope
    }, initialValue);
  }
  return descriptor;
};